angular
	.module 'App.Component'
	.component 'advancedSearch',
		{
			templateUrl: '@component/advanced-search/advanced-search.view.html'
			controller: 'AdvancedSearchComponent'
			controllerAs: 'advancedSearch'
			bindings:
				configuration: '<'
				wideView: '<?'
				hasHeader: '<?'
				onChange: '&?'
				onBeforeSearch: '&?'
		}

class AdvancedSearchComponent extends AbstractController
	@register()
	@inject '$scope'

	initialize: ->
		@wideView ?= false
		@hasHeader ?= true

		@$scope.$watch 'advancedSearch.form.$valid', (newValue) =>
			@configuration.valid = newValue
